import styles from "./style.module.css"

export interface ICartItemDescriptionProp{
  itemName?: string;
  artistName?: string;
  itemSize?: string;
  itemPrice?: string;
}

const formatter = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const CartItemDescription = ({itemName = "", artistName, itemSize= "", itemPrice= ""}: ICartItemDescriptionProp) =>{

     return(

<div className={styles.container}>
  <div className={styles.head}>{itemName}</div>
  <div><span className={styles.label}>Artist :</span> {artistName}</div>
  <div><span className={styles.label}>Size :</span> {itemSize}</div>
  <div><span className={styles.label}>Price :</span> {formatter.format(Number(itemPrice))}</div>
</div>

// 6A6A6A

     )

}